import { RootState } from '@/App/store';

export const selectPresentationModeEnabled = (state: RootState) => state.ui.presentationMode.enabled;
